document.addEventListener('DOMContentLoaded', function () {
  const storageKey = 'selectedUpsellSwatch';
  const cards = document.querySelectorAll('.single-upsell__variant-card');

  let selected = localStorage.getItem(storageKey);

  function updateUI(swatchValue) {
    cards.forEach((card) => {
      const swatches = card.querySelectorAll('.sale-addon-swatch');
      const selectedColorName = card.querySelector('.selected-color-name');

      swatches.forEach((s) => {
        const isActive = s.getAttribute('data-swatch') === swatchValue;
        s.classList.toggle('active', isActive);
        if (isActive && selectedColorName) {
          const formatted = s.getAttribute('data-swatch')
            .replace(/-/g, ' ')
            .replace(/\b\w/g, (c) => c.toUpperCase());
            selectedColorName.innerHTML = '<strong>COLOUR:</strong> ' + formatted;
        }
      });

      const isVisible = card.getAttribute('data-option2') === swatchValue;
      card.style.display = isVisible ? 'flex' : 'none';
    });
  }

  cards.forEach((card) => {
    const swatches = card.querySelectorAll('.sale-addon-swatch');

    swatches.forEach((swatch) => {
      swatch.addEventListener('click', () => {
        const selected = swatch.getAttribute('data-swatch');
        localStorage.setItem(storageKey, selected);
        updateUI(selected);
      });
    });
  });

  if (selected && document.querySelector(`.sale-addon-swatch[data-swatch="${selected}"]`)) {
    updateUI(selected);
  } else {
    const firstCard = document.querySelector('.single-upsell__variant-card');
    if (firstCard) {
      const defaultSwatch = firstCard.querySelector('.sale-addon-swatch')?.getAttribute('data-swatch');
      if (defaultSwatch) {
        updateUI(defaultSwatch);
        localStorage.setItem(storageKey, defaultSwatch);
      }
    }
  }
});
